import { Link } from "react-router-dom";
import Layout from "../components/Layout";
import joshpic from '../images/icons/josh_pic3.png'

const About = () => {

    const skills = [
        {group: 'Mobile', items: ['Expo', 'React Native', 'Firebase']},
        {group: 'Front-end', items: ['React', 'JavaScript', 'CSS']},
        {group: 'Design & tools', items: ['Figma', 'Claude Code']},
        {group: 'Currently learning', items: ['UI/UX Design']},
    ]

    const qualifications = [
        {name: 'BSc (Biochemistry)', institution: 'University of Otago', year: 2008},
        {name: 'BMus (Jazz Saxophone Performance)', institution: 'New Zealand School of Music', year: 2011},
        {name: 'DipGrad (Biochemistry)', institution: 'University of Otago', year: 2012},
        {name: 'Diploma in Web Development', institution: 'Enspiral Dev Academy', year: 2020},
    ]

    return (
    <Layout>
        <p className="eyebrow">About</p>
        <h1 className="page-title">About Josh</h1>
        <div className="about-intro">
            <div className="about-text">
                <p>
                    Hi, I'm Josh - a Wellington-based developer who likes building things that are useful to
                    people, especially the local creative scene. Most recently that's <Link to = '/projects/gig-fort'>Gig Fort</Link>, a live music gig guide
                    app for Wellington that I designed, built and released myself, and I'm currently working on a
                    mobile app contract.
                </p>
                <p>
                    I took a less direct route into tech. I studied biochemistry for my Bachelor of Science, then
                    completed a graduate diploma that included a year-long research project and thesis. I also hold a
                    degree in jazz saxophone performance from the New Zealand School of Music, and have led a number of
                    ensembles - from groups playing original music to a salsa band. I still write my own music, which you
                    can hear <a href = 'https://soundcloud.com/josh-simon-264281792'>here</a>.
                </p>
                <p>
                    I came to web development through a bootcamp with
                    Enspiral Dev Academy, and what keeps me at it is the satisfaction of making something useful. My
                    strengths are mobile app development (Expo, Firebase and Figma), front-end development, and working
                    effectively with AI tools like Claude Code. I'm keen to keep growing in UI/UX design.
                </p>
                <p>
                    I'm looking for part-time work in tech or anything tech-adjacent - if that sounds like a fit, <Link to = '/contact'>get in touch</Link>.
                </p>
            </div>
            <img className="about-photo" src = {joshpic} alt = 'Josh playing tenor saxophone on stage'/>
        </div>

        <section className="section">
            <h2 className="section-title">Key skills</h2>
            <div className="skill-grid">
                {skills.map(skill => (
                    <div className="skill-group" key = {skill.group}>
                        <h3>{skill.group}</h3>
                        <ul className="chips">
                            {skill.items.map(item => <li className="chip" key = {item}>{item}</li>)}
                        </ul>
                    </div>
                ))}
            </div>
        </section>

        <section className="section">
            <h2 className="section-title">Qualifications</h2>
            <ul className="qual-list">
                {qualifications.map(item => (
                    <li className="qual-item" key = {item.name}>
                        <span className="qual-year">{item.year}</span>
                        <div>
                            <h3>{item.name}</h3>
                            <p>{item.institution}</p>
                        </div>
                    </li>
                ))}
            </ul>
        </section>
    </Layout>
    )
}

export default About;
